import React, { useState, useEffect, useCallback } from "react";
import { observer } from "mobx-react-lite";

import Svg from "../svg/Svg";
import MenuItem, { MenuItemProps } from "./MenuItem";
import { Collapse as CollapseIcon } from "../svg/svgImageList";
import useThemeService from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";

export interface MenuSection {
  labelKey: string | JSX.Element;
  items: Array<MenuItemProps>;
  menuCategory: string;
  defaultOpen: boolean;
}

export default observer(function MenuSection(props: MenuSection) {
  const { themeClass } = useThemeService();

  const { labelKey, items, menuCategory, defaultOpen } = { ...props };

  const [open, setOpen] = useState(defaultOpen);

  const toggleOpen = useCallback(() => {
    setOpen((open) => !open);
  }, []);

  useEffect(() => {
    const pathArray = window.location.pathname.split("/");
    for (let i = 0; i < items.length; i++) {
      const pageSection = items[i].path.split("/")[1];
      if (pathArray.some((pathSection) => pathSection === pageSection)) {
        setOpen(true);
        return;
      }
    }
  }, [items]);

  return (
    <section className={themeClass(["secondary-menu-section"])}>
      <div
        className="secondary-menu-section-header"
        onClick={() => {
          !defaultOpen && toggleOpen();
        }}
      >
        <label>
          {typeof labelKey === "string" ? translationService.translate(labelKey) : labelKey}
        </label>
        <Svg
          svg={CollapseIcon}
          className={themeClass(
            ["secondary-menu-collapse"],
            [defaultOpen ? "hidden-arrow" : open ? "down-arrow" : "up-arrow"]
          )}
        />
      </div>
      {open &&
        items.map((item) => (
          <MenuItem
            key={item.labelKey}
            id={item.id}
            labelKey={item.labelKey}
            path={`/${menuCategory}${item.path}`}
            disabled={item.disabled}
            canAccess={item.canAccess}
            isActive={item.isActive}
          />
        ))}
    </section>
  );
});
